const options = {
  threshold: [1.0]
};
let observer;

function createObserver() {
  if(observer) return;
  observer = new IntersectionObserver(function(entries, observer){
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        entry.target.classList.add(entry.target._interserctionobserver_classes);
        observer.unobserve(entry.target);
      }
    })
  }, options);
}

export default function(el, classes) {
  createObserver();
  el._interserctionobserver_classes = classes;
  observer.observe(el);
}
